module.exports = __webpack_public_path__ + "static/media/fitness.7a147ac4.avif";